import {
  ErrorPage,
  FailedIdentification,
  FailedIdentificationFinalPage,
  Loader,
  useGetCreditApplicationById,
} from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useParams } from 'react-router-dom'

const FailedIdentificationPage = () => {
  const { id } = useParams()
  const [creditApp, loading] = useGetCreditApplicationById(id!, EFinancingProgram.B2c)

  if (loading) return <Loader />
  if (!creditApp) return <ErrorPage />
  const vouchedFailedCount = creditApp.applicant.vouchedFailedCount || 0
  if (vouchedFailedCount > 1) return <FailedIdentificationFinalPage creditApp={creditApp} />

  return <FailedIdentification creditApp={creditApp} retryHref={`/creditApplication/${creditApp.id}/vouched`} />
}

export default FailedIdentificationPage
